import { Component, OnInit, Input } from '@angular/core';
import { TextFont} from '../../types';

@Component({
  selector: 'g[svg-text]',
  templateUrl: './svgtext.component.html',
  styleUrls: ['./svgtext.component.css']
})
export class SvgTextComponent implements OnInit {

  constructor() { }

  @Input()
  public x: number;

  @Input()
  public y: number;

  @Input()
  public transform: number;

  @Input()
  public fontStyle: TextFont;

  ngOnInit() {
  }

}
